import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function Loader(_: Props) {
  return (
    <div className={styles.loader}>
      <div className={styles.row}>
        <div className={styles.breadcrumbs}>
          <Skeleton className={styles.breadcrumb} />
          <Skeleton className={styles.breadcrumb} />
        </div>
        <Skeleton className={styles.date} />
      </div>
      <div className={styles.main}>
        <div className={styles.breadcrumbs}>
          <Skeleton className={styles.resource} />
          <Skeleton className={styles.text} />
        </div>
        <Skeleton className={styles.text} />
      </div>
    </div>
  );
}

export { Loader };
